<div *ngIf="vm">
  <div class="progress-cls"></div>
  <div *ngIf="vm.showProgressSpinner" class="spinner-overlay">
    <div class="lmask"></div>
  </div>

  <!-- Generator Edit Container Start -->
  <div *ngIf="vm.assetType === 'Generator'" class="generator-container">
    <form #generatorEditForm="ngForm">
      <mat-tab-group [(selectedIndex)]="vm.generatorTabIndex">
        <mat-tab>
          <ng-template mat-tab-label>
            <p class="mb-0">Generator Informations</p>
          </ng-template>
          <div class="wrapper">
            <mat-form-field class="mat-form-field-infix-class">
              <input matInput name="assetId" placeholder="QR Code Asset Id" type="text" [(ngModel)]="vm.assetId"
                     (blur)="trimGeneratorLeadingAndTrailingSpaces('assetId')" />
              <button
                class="search-button"
                mat-mini-fab
                matSuffix
                type="button"
                [attr.aria-label]="vm.scannerEnabled ? 'Close scanner' : 'Open scanner'"
                (click)="enableScanner()">
                <mat-icon>qr_code_scanner</mat-icon>
              </button>
            </mat-form-field>

            <div *ngIf="vm.scannerEnabled" class="scanner-container">
              <zxing-scanner
                #scanner
                class="qr-reader"
                (scanSuccess)="scanSuccessHandler($event)">
              </zxing-scanner>
              <div #focusFrame *ngIf="vm.zoomFlag" class="focus-frame"></div>
              <div *ngIf="vm.zoomFlag" class="zoom-controls">
                <button aria-label="Zoom in" class="zoom-icon" type="button" (click)="zoomIn()">
                  <span aria-hidden="true" class="fa fa-search-plus"></span>
                </button>
                <button aria-label="Zoom out" class="zoom-icon" type="button" (click)="zoomOut()">
                  <span aria-hidden="true" class="fa fa-search-minus"></span>
                </button>
              </div>
            </div>

            <mat-form-field class="mat-form-field-infix-class">
              <input matInput name="localId" placeholder="Local ID" type="text" [(ngModel)]="vm.localId"
                     (blur)="trimGeneratorLeadingAndTrailingSpaces('localId')" />
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <mat-select #statusCtrl="ngModel" name="status" placeholder="Status" required
                          [(ngModel)]="vm.selectedStatus" (selectionChange)="onStatusChange($event.value)">
                <mat-option>--</mat-option>
                <mat-option *ngFor="let status of vm.statuses; trackBy: trackByStatus" [value]="status.id">
                  {{ status.statusType }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="statusCtrl.invalid && statusCtrl.touched">Status is required</mat-error>
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <input #serialNumberCtrl="ngModel" matInput name="serialNumber" placeholder="Serial Number" required
                     type="text" [(ngModel)]="vm.serialNumber"
                     (blur)="trimGeneratorLeadingAndTrailingSpaces('serialNumber')" />
              <mat-error *ngIf="serialNumberCtrl.invalid && serialNumberCtrl.touched">
                Serial Number is required
              </mat-error>
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <mat-select #manufacturerCtrl="ngModel" name="manufacturer" placeholder="Manufacturer" required
                          [(ngModel)]="vm.selectedManufacturer" (selectionChange)="onManufacturerChange($event.value)">
                <mat-option>--</mat-option>
                <mat-option *ngFor="let manufacturer of vm.manufacturers; trackBy: trackByManufacturer"
                            [value]="manufacturer.id">
                  {{ manufacturer.manufacture }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="manufacturerCtrl.invalid && manufacturerCtrl.touched">
                Manufacturer is required
              </mat-error>
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <mat-select #modelCtrl="ngModel" name="model" placeholder="Model" required
                          [(ngModel)]="vm.selectedModel" (selectionChange)="onModelChange($event.value)">
                <mat-option>--</mat-option>
                <mat-option *ngFor="let model of vm.models; trackBy: trackByModel" [value]="model.id">
                  {{ model.genModel }}
                </mat-option>
              </mat-select>
              <mat-hint *ngIf="!vm.selectedManufacturer">Select Manufacturer first</mat-hint>
              <mat-hint *ngIf="vm.selectedManufacturer && !vm.models.length">No Models Found</mat-hint>
              <mat-error *ngIf="modelCtrl.invalid && modelCtrl.touched">
                Model is required
              </mat-error>
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <mat-select #currentTypeCtrl="ngModel" name="currentType" placeholder="Current Type" required
                          [(ngModel)]="vm.selectedCurrentType">
                <mat-option>--</mat-option>
                <mat-option *ngFor="let currentType of vm.currentTypes; trackBy: trackByCurrentType"
                            [value]="currentType?.currentType">
                  {{ currentType?.currentType }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="currentTypeCtrl.invalid && currentTypeCtrl.touched">
                Current Type is required
              </mat-error>
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <mat-select #voltageCtrl="ngModel" name="outputVoltage" placeholder="Output Voltage" required
                          [(ngModel)]="vm.selectedVoltage">
                <mat-option>--</mat-option>
                <mat-option *ngFor="let voltageType of vm.voltageTypes; trackBy: trackByVoltageType"
                            [value]="voltageType.voltage">
                  {{ voltageType.voltage }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="voltageCtrl.invalid && voltageCtrl.touched">
                Voltage Type is required
              </mat-error>
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <mat-select #divisionCtrl="ngModel" name="division" placeholder="Division" required
                          [(ngModel)]="vm.selectedDivision" (selectionChange)="onDivisionChange($event.value)">
                <mat-option>--</mat-option>
                <mat-option *ngFor="let division of vm.divisions; trackBy: trackByDivision" [value]="division.elementID">
                  {{ division.name }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="divisionCtrl.invalid && divisionCtrl.touched">
                Division is required
              </mat-error>
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <mat-select #regionCtrl="ngModel" name="region" placeholder="Region" required
                          [(ngModel)]="vm.selectedRegion" [disabled]="vm.isRegionsLoading"
                          (selectionChange)="onRegionChange($event.value)">
                <mat-option>--</mat-option>
                <mat-option *ngFor="let region of vm.regions; trackBy: trackByRegion" [value]="region.elementID">
                  {{ region.name }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="regionCtrl.invalid && regionCtrl.touched">
                Region is required
              </mat-error>
              <mat-hint *ngIf="vm.isRegionsLoading ||
                               (!vm.isRegionsLoading &&
                               (!vm.regions?.length > 0 ||
                               !vm.regions))">
                Select a division first
              </mat-hint>
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <input matInput name="ownerContact" placeholder="Owner & Contact" type="text"
                     [(ngModel)]="vm.ownerContact" (blur)="trimGeneratorLeadingAndTrailingSpaces('ownerContact')" />
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <mat-select #ownerTeamCtrl="ngModel" name="ownerTeam" placeholder="Owner Team" required
                          [(ngModel)]="vm.selectedTeam" [disabled]="vm.isTeamsLoading"
                          (selectionChange)="onTeamChange($event.value)">
                <mat-option>--</mat-option>
                <mat-option *ngFor="let team of vm.teams; trackBy: trackByTeam" [value]="team">
                  {{team}}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="ownerTeamCtrl.invalid && ownerTeamCtrl.touched">
                Owner Team is required
              </mat-error>
              <mat-hint *ngIf="!vm.selectedRegion">Select a region first</mat-hint>
              <mat-hint *ngIf="vm.selectedRegion && vm.isTeamsLoading">Loading teams...</mat-hint>
              <mat-hint *ngIf="vm.selectedRegion && !vm.isTeamsLoading && !(vm.teams?.length > 0)">
                No teams found
              </mat-hint>
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <mat-select name="trailerId" placeholder="Trailer Name"
                          [(ngModel)]="vm.selectedTrailer"
                          [disabled]="vm.isTrailerLoading">
                <mat-option>--</mat-option>
                <mat-option *ngFor="let trailer of vm.trailers; trackBy: trackByTrailerId" [value]="trailer.trailerId">
                  {{ trailer.trailerName ? trailer.trailerName : 'Anonymous Trailer' }}
                </mat-option>
              </mat-select>
              <mat-hint *ngIf="!vm.selectedTeam">Select a Owner Team first</mat-hint>
              <mat-hint *ngIf="vm.selectedTeam && vm.isTrailerLoading">Loading Trailers...</mat-hint>
              <mat-hint *ngIf="vm.selectedTeam && !vm.isTrailerLoading && !vm.trailers.length">
                No Trailers Found
              </mat-hint>
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <mat-select name="loanedToTeam" placeholder="Loaned To Team" [(ngModel)]="vm.selectedLoanedToTeam">
                <mat-option>--</mat-option>
                <mat-option *ngFor="let team of vm.loanedToTeams; trackBy: trackByTeam" [value]="team">
                  {{team}}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <mat-select name="maintenance" placeholder="Maintenance" [(ngModel)]="vm.selectedMaintenance">
                <mat-option>--</mat-option>
                <mat-option *ngFor="let maintenance of vm.maintenances; trackBy: trackByMaintenance"
                            [value]="maintenance.maintenance">
                  {{ maintenance.maintenance }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <input matInput name="generatorCord" placeholder="Generator Cord" type="text"
                     [(ngModel)]="vm.generatorCord" (blur)="trimGeneratorLeadingAndTrailingSpaces('generatorCord')" />
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <input matInput name="generatorChain" placeholder="Generator Chain" type="text"
                     [(ngModel)]="vm.generatorChain" (blur)="trimGeneratorLeadingAndTrailingSpaces('generatorChain')" />
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <input matInput name="generatorLock" placeholder="Generator Lock" type="text"
                     [(ngModel)]="vm.generatorLock" (blur)="trimGeneratorLeadingAndTrailingSpaces('generatorLock')" />
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <mat-label for="generatorComments">Comments</mat-label>
              <textarea id="generatorComments" matInput name="comments" rows="3" [(ngModel)]="vm.comments"
                        (blur)="trimGeneratorLeadingAndTrailingSpaces('comments')">
                  </textarea>
            </mat-form-field>
          </div>
        </mat-tab>

        <mat-tab>
          <ng-template mat-tab-label>
            <p class="mb-0">Location Information</p>
          </ng-template>
          <div class="wrapper">
            <mat-form-field class="mat-form-field-infix-class">
              <input matInput name="address" placeholder="Address" type="text" [(ngModel)]="vm.address"
                     (blur)="trimGeneratorLeadingAndTrailingSpaces('address')" />
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <input matInput name="city" placeholder="City" type="text" [(ngModel)]="vm.city"
                     (blur)="trimGeneratorLeadingAndTrailingSpaces('city')" />
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <mat-select name="state" placeholder="State" [(ngModel)]="vm.selectedState">
                <mat-option>--</mat-option>
                <mat-option *ngFor="let state of vm.states; trackBy: trackByState" [value]="state.name">
                  {{ state.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <input matInput maxlength="5" minlength="5" name="zipcode" placeholder="Zip code" type="text"
                     [(ngModel)]="vm.zipcode" (blur)="trimGeneratorLeadingAndTrailingSpaces('zipcode')"
                     (keypress)="numberOnly($event)" (paste)="restrictPasteForText($event)" />
            </mat-form-field>

            <form *ngIf="vm.generatorLocationInfoForm" [formGroup]="vm.generatorLocationInfoForm">
              <mat-form-field class="mat-form-field-bottom-margin mat-form-field-infix-class">
                <input formControlName="currentGpsLatitude" matInput placeholder="Current Gps Latitude xx.xxxxxx"
                       (change)="trimSpaces('vm.currentGpsLatitude')"
                       (ngModelChange)="onChangeLocation(vm.generatorLocationInfoForm)">
                <mat-error *ngIf="vm.generatorLocationInfoForm?.get('currentGpsLatitude')?.hasError('validateDecimal')">
                  Latitude <span class="text-type-bold">Must</span>
                  Be 6-12 Characters After Decimal and Correctly Formatted !
                </mat-error>
                <mat-error *ngIf="vm.generatorLocationInfoForm?.get('currentGpsLatitude')?.hasError('validateRange')">
                  {{ vm.generatorLocationInfoForm?.get('currentGpsLatitude')?.errors?.validateRange }}
                </mat-error>
              </mat-form-field>

              <mat-form-field class="mat-form-field-bottom-margin mat-form-field-infix-class">
                <input formControlName="currentGpsLongitude" matInput placeholder="Current Gps Longitude -xx.xxxxxx"
                       (change)="trimSpaces('vm.currentGpsLongitude')"
                       (ngModelChange)="onChangeLocation(vm.generatorLocationInfoForm)">
                <mat-error *ngIf="vm.generatorLocationInfoForm?.get('currentGpsLongitude')?.hasError('validateDecimal')">
                  Longitude <span class="text-type-bold">Must</span>
                  Be 6-12 Characters After Decimal and Correctly Formatted !
                </mat-error>
                <mat-error *ngIf="vm.generatorLocationInfoForm?.get('currentGpsLongitude')?.hasError('validateRange')">
                  {{ vm.generatorLocationInfoForm?.get('currentGpsLongitude')?.errors?.validateRange }}
                </mat-error>
                <span class="mac-button" matSuffix><span class="fa fa-mouse-pointer" matSuffix></span>
                  <a href="https://www.google.com/maps/search/?api=1&query={{vm.generatorLocationInfoForm?.value?.currentGpsLatitude}},{{vm.generatorLocationInfoForm?.value?.currentGpsLongitude}}"
                    target="_blank">Show on Map</a>
                </span>
              </mat-form-field>
            </form>
          </div>
        </mat-tab>
      </mat-tab-group>
    </form>
  </div>

  <!-- Trailer Edit Container Start -->
  <div *ngIf="vm.assetType === 'Trailer'" class="trailer-container">
    <form #trailerEditForm="ngForm">
      <mat-tab-group [(selectedIndex)]="vm.trailerTabIndex">
        <mat-tab>
          <ng-template mat-tab-label>
            <p class="mb-0">Trailer Informations</p>
          </ng-template>
          <div class="wrapper">
            <mat-form-field class="mat-form-field-infix-class">
              <input matInput name="trailerAssetId"
                     placeholder="QR Code Asset Id" type="text"
                     [(ngModel)]="vm.trailerAssetId"
                     (blur)="trimGeneratorLeadingAndTrailingSpaces('trailerAssetId')" />
              <button
                class="search-button"
                mat-mini-fab
                matSuffix
                type="button"
                [attr.aria-label]="vm.trailerScannerEnabled ? 'Close scanner' : 'Open scanner'"
                (click)="enableTrailerScanner()">
                <mat-icon>qr_code_scanner</mat-icon>
              </button>
            </mat-form-field>

            <div *ngIf="vm.trailerScannerEnabled" class="scanner-container">
              <zxing-scanner
                #trailerScanner
                class="qr-reader"
                (scanSuccess)="trailerScanSuccessHandler($event)">
              </zxing-scanner>
              <div #focusFrame *ngIf="vm.trailerZoomFlag" class="focus-frame"></div>
              <div *ngIf="vm.trailerZoomFlag" class="zoom-controls">
                <button aria-label="Zoom in" class="zoom-icon" type="button" (click)="trailerZoomIn()">
                  <span aria-hidden="true" class="fa fa-search-plus"></span>
                </button>
                <button aria-label="Zoom out" class="zoom-icon" type="button" (click)="trailerZoomOut()">
                  <span aria-hidden="true" class="fa fa-search-minus"></span>
                </button>
              </div>
            </div>

            <mat-form-field class="mat-form-field-infix-class">
              <input matInput name="trailerLocalId" placeholder="Local ID" type="text" [(ngModel)]="vm.trailerLocalId"
                     (blur)="trimGeneratorLeadingAndTrailingSpaces('trailerLocalId')" />
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <input matInput name="trailerSerialNumber"
                     placeholder="Serial Number" type="text"
                     [(ngModel)]="vm.trailerSerialNumber"
                     (blur)="trimGeneratorLeadingAndTrailingSpaces('trailerSerialNumber')" />
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <mat-select #statusCtrl="ngModel" name="trailerStatus" placeholder="Status" required
                          [(ngModel)]="vm.trailerSelectedStatus" (selectionChange)="onStatusChange($event.value)">
                <mat-option>--</mat-option>
                <mat-option *ngFor="let status of vm.statuses; trackBy: trackByStatus" [value]="status.id">
                  {{ status.statusType }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="statusCtrl.invalid && statusCtrl.touched">
                Status is required
              </mat-error>
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <input matInput name="trailerName" placeholder="Trailer Name" type="text" [(ngModel)]="vm.trailerName"
                     (blur)="trimGeneratorLeadingAndTrailingSpaces('trailerName')" />
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <input #trailerSizeCtrl="ngModel" matInput name="trailerSize" placeholder="Trailer Size" required
                     type="text" [(ngModel)]="vm.trailerSize"
                     (blur)="trimGeneratorLeadingAndTrailingSpaces('trailerSize')" />
              <mat-error *ngIf="trailerSizeCtrl.invalid && trailerSizeCtrl.touched">
                Trailer Size is required
              </mat-error>
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <input #trailerHeightCtrl="ngModel" matInput name="trailerHeight" placeholder="Trailer Height" required
                     type="text" [(ngModel)]="vm.trailerHeight"
                     (blur)="trimGeneratorLeadingAndTrailingSpaces('trailerHeight')" />
              <mat-error *ngIf="trailerHeightCtrl.invalid && trailerHeightCtrl.touched">
                Trailer Height is required
              </mat-error>
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <mat-select #divisionCtrl="ngModel" name="trailerDivision" placeholder="Division" required
                          [(ngModel)]="vm.trailerSelectedDivision"
                          (selectionChange)="onTrailerDivisionChange($event.value)">
                <mat-option>--</mat-option>
                <mat-option *ngFor="let division of vm.divisions; trackBy: trackByDivision" [value]="division.elementID">
                  {{ division.name }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="divisionCtrl.invalid && divisionCtrl.touched">
                Division is required
              </mat-error>
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <mat-select #regionCtrl="ngModel" name="trailerRegion" placeholder="Region" required
                          [(ngModel)]="vm.trailerSelectedRegion" [disabled]="vm.isRegionsLoading"
                          (selectionChange)="onTrailerRegionChange($event.value)">
                <mat-option>--</mat-option>
                <mat-option *ngFor="let region of vm.regions; trackBy: trackByRegion" [value]="region.elementID">
                  {{ region.name }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="regionCtrl.invalid && regionCtrl.touched">Region is required</mat-error>
              <mat-hint *ngIf="vm.isRegionsLoading">Loading regions...</mat-hint>
              <mat-hint *ngIf="!vm.isRegionsLoading && !(vm.regions?.length > 0)">Select a division first</mat-hint>
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <mat-select #ownerTeamCtrl="ngModel" name="trailerTeam" placeholder="Owner Team" required
                          [(ngModel)]="vm.selectedTeam" [disabled]="vm.isTeamsLoading">
                <mat-option>--</mat-option>
                <mat-option *ngFor="let team of vm.teams; trackBy: trackByTeam" [value]="team">
                  {{ team }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="ownerTeamCtrl.invalid && ownerTeamCtrl.touched">
                Team is required
              </mat-error>
              <mat-hint *ngIf="!vm.trailerSelectedRegion">Select a region first</mat-hint>
              <mat-hint *ngIf="vm.trailerSelectedRegion && vm.isTeamsLoading">Loading teams...</mat-hint>
              <mat-hint *ngIf="vm.trailerSelectedRegion && !vm.isTeamsLoading && !(vm.teams?.length > 0)">
                No teams found
              </mat-hint>
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <mat-select name="trailerLoanedToTeam"
                          placeholder="Loaned To Team"
                          [(ngModel)]="vm.trailerSelectedLoanedToTeam">
                <mat-option>--</mat-option>
                <mat-option *ngFor="let team of vm.loanedToTeams; trackBy: trackByTeam" [value]="team">
                  {{ team }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <input #licensePlateCtrl="ngModel" matInput name="licensePlate" placeholder="License Plate" required
                     type="text" [(ngModel)]="vm.trailerLicensePlate"
                     (blur)="trimGeneratorLeadingAndTrailingSpaces('trailerLicensePlate')" />
              <mat-error *ngIf="licensePlateCtrl.invalid && licensePlateCtrl.touched">
                License Plate is required
              </mat-error>
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <input matInput name="generatorCapacity" placeholder="Generator Capacity" type="text"
                     [(ngModel)]="vm.trailerGeneratorCapacity"
                     (blur)="trimGeneratorLeadingAndTrailingSpaces('trailerGeneratorCapacity')"
                     (keypress)="numberOnly($event)" (paste)="restrictPasteForText($event)" />
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <mat-select #cdlRequiredCtrl="ngModel" name="cdlRequired" placeholder="CDL Required?" required
                          [(ngModel)]="vm.trailerCdlRequired">
                <mat-option>--</mat-option>
                <mat-option [value]="1">Yes</mat-option>
                <mat-option [value]="0">No</mat-option>
              </mat-select>
              <mat-error *ngIf="cdlRequiredCtrl.invalid && cdlRequiredCtrl.touched">
                CDL Required? field is required
              </mat-error>
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <mat-select name="awayFromHome" placeholder="Away From Home?" [(ngModel)]="vm.trailerAwayFromHome">
                <mat-option>--</mat-option>
                <mat-option [value]="1">Yes</mat-option>
                <mat-option [value]="0">No</mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <input #hitchSizeCtrl="ngModel" matInput name="hitchSize" placeholder="Hitch Size" required type="text"
                     [(ngModel)]="vm.trailerHitchSize"
                     (blur)="trimGeneratorLeadingAndTrailingSpaces('trailerHitchSize')" />
              <mat-error *ngIf="hitchSizeCtrl.invalid && hitchSizeCtrl.touched">
                Hitch Size is required
              </mat-error>
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <input #hitchTypeCtrl="ngModel" matInput name="hitchType" placeholder="Hitch Type" required type="text"
                     [(ngModel)]="vm.trailerHitchType"
                     (blur)="trimGeneratorLeadingAndTrailingSpaces('trailerHitchType')" />
              <mat-error *ngIf="hitchTypeCtrl.invalid && hitchTypeCtrl.touched">
                Hitch Type is required
              </mat-error>
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <input #primaryContactCtrl="ngModel" matInput name="primaryContact" placeholder="Primary Contact" required
                     type="text" [(ngModel)]="vm.trailerPrimaryContact"
                     (blur)="trimGeneratorLeadingAndTrailingSpaces('trailerPrimaryContact')" />
              <mat-error *ngIf="primaryContactCtrl.invalid && primaryContactCtrl.touched">
                Primary Contact is required
              </mat-error>
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <input matInput name="secondaryContact" placeholder="Secondary Contact" type="text"
                     [(ngModel)]="vm.trailerSecondaryContact"
                     (blur)="trimGeneratorLeadingAndTrailingSpaces('trailerSecondaryContact')" />
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <input #lockTypeCtrl="ngModel" matInput name="lockType" placeholder="Lock Type" required type="text"
                     [(ngModel)]="vm.trailerLockType" (blur)="trimGeneratorLeadingAndTrailingSpaces('trailerLockType')" />
              <mat-error *ngIf="lockTypeCtrl.invalid && lockTypeCtrl.touched">
                Lock Type is required
              </mat-error>
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <input #lockCombinationCtrl="ngModel" matInput name="lockCombination" placeholder="Lock Combination"
                     required type="text" [(ngModel)]="vm.trailerLockCombination"
                     (blur)="trimGeneratorLeadingAndTrailingSpaces('trailerLockCombination')" />
              <mat-error *ngIf="lockCombinationCtrl.invalid && lockCombinationCtrl.touched">
                Lock Combination is required
              </mat-error>
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <mat-label for="trailerComments">Comments</mat-label>
              <textarea id="trailerComments" matInput name="trailerComments" rows="3" [(ngModel)]="vm.trailerComments"
                        (blur)="trimGeneratorLeadingAndTrailingSpaces('trailerComments')">
              </textarea>
            </mat-form-field>
          </div>
        </mat-tab>

        <mat-tab>
          <ng-template mat-tab-label>
            <p class="mb-0">Location Information</p>
          </ng-template>
          <div class="wrapper">
            <mat-form-field class="mat-form-field-infix-class">
              <input #houseNumberInputCtrl="ngModel" matInput name="houseNumberInput" placeholder="House Number"
                     required type="text" [(ngModel)]="vm.trailerHouseNumber"
                     (blur)="trimGeneratorLeadingAndTrailingSpaces('trailerHouseNumber')">
              <mat-error *ngIf="houseNumberInputCtrl.invalid && houseNumberInputCtrl.touched">
                House Number is required
              </mat-error>
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <input #streetCtrl="ngModel" matInput name="street" placeholder="Street" required [(ngModel)]="vm.trailerStreet"
                     (blur)="trimGeneratorLeadingAndTrailingSpaces('trailerStreet')">
              <mat-error *ngIf="streetCtrl.invalid && streetCtrl.touched">
                Street is required
              </mat-error>
              <span class="mac-button" matSuffix><span class="fa fa-mouse-pointer" matSuffix></span>
                <a href="https://www.google.com/maps/place/{{vm.trailerHouseNumber}}+{{vm.trailerStreet}}+{{vm.trailerCity}}+{{vm.trailerSelectedState}}+{{vm.trailerZip}}"
                   target='_blank'>Show on Map</a>
              </span>
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <input #cityCtrl="ngModel" matInput name="city" placeholder="City" required [(ngModel)]="vm.trailerCity"
                     (blur)="trimGeneratorLeadingAndTrailingSpaces('trailerCity')">
              <mat-error *ngIf="cityCtrl.invalid && cityCtrl.touched">
                City is required
              </mat-error>
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <mat-select #stateCtrl="ngModel" name="state" placeholder="State" required [(ngModel)]="vm.trailerSelectedState">
                <mat-option>--</mat-option>
                <mat-option *ngFor="let state of vm.states; trackBy: trackByState" [value]="state.name">
                  {{ state.name }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="stateCtrl.invalid && stateCtrl.touched">
                State is required
              </mat-error>
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <input #zipCtrl="ngModel" matInput maxlength="5" minlength="5" name="zip" placeholder="Zip Code" required
                     [(ngModel)]="vm.trailerZip" (blur)="trimGeneratorLeadingAndTrailingSpaces('trailerZip')"
                     (keypress)="numberOnly($event)" (paste)="restrictPasteForText($event)">
              <mat-error *ngIf="zipCtrl.invalid && zipCtrl.touched">
                Zip is required and must be 5 digits
              </mat-error>
            </mat-form-field>

            <form *ngIf="vm.trailerLocationInfoForm" [formGroup]="vm.trailerLocationInfoForm">
              <mat-form-field class="mat-form-field-bottom-margin mat-form-field-infix-class">
                <input formControlName="currentGpsLatitude" matInput placeholder="Current Gps Latitude xx.xxxxxx"
                       (change)="trimSpaces('vm.currentGpsLatitude')"
                       (ngModelChange)="onChangeLocation(vm.trailerLocationInfoForm)">
                <mat-error *ngIf="vm.trailerLocationInfoForm?.get('currentGpsLatitude')?.hasError('validateDecimal')">
                  Latitude <span class="text-type-bold">Must</span>
                  Be 6-12 Characters After Decimal and Correctly Formatted !
                </mat-error>
                <mat-error *ngIf="vm.trailerLocationInfoForm?.get('currentGpsLatitude')?.hasError('validateRange')">
                  {{ vm.trailerLocationInfoForm?.get('currentGpsLatitude')?.errors?.validateRange }}
                </mat-error>
              </mat-form-field>

              <mat-form-field class="mat-form-field-bottom-margin mat-form-field-infix-class">
                <input formControlName="currentGpsLongitude" matInput placeholder="Current Gps Longitude -xx.xxxxxx"
                       (change)="trimSpaces('vm.currentGpsLongitude')"
                       (ngModelChange)="onChangeLocation(vm.trailerLocationInfoForm)">
                <mat-error *ngIf="vm.trailerLocationInfoForm?.get('currentGpsLongitude')?.hasError('validateDecimal')">
                  Longitude <span class="text-type-bold">Must</span>
                  Be 6-12 Characters After Decimal and Correctly Formatted !
                </mat-error>
                <mat-error *ngIf="vm.trailerLocationInfoForm?.get('currentGpsLongitude')?.hasError('validateRange')">
                  {{ vm.trailerLocationInfoForm?.get('currentGpsLongitude')?.errors?.validateRange }}
                </mat-error>
                <span class="mac-button" matSuffix><span class="fa fa-mouse-pointer" matSuffix></span>
                  <a href="https://www.google.com/maps/search/?api=1&query={{vm.trailerLocationInfoForm?.value?.currentGpsLatitude}},{{vm.trailerLocationInfoForm?.value?.currentGpsLongitude}}"
                     target="_blank">Show on Map</a>
                </span>
              </mat-form-field>
            </form>
          </div>
        </mat-tab>
      </mat-tab-group>
    </form>
  </div>

  <!-- Fuel Tank Edit Container Start -->
  <div *ngIf="vm.assetType === 'Fueltank'" class="fuel-tank-container">
    <form #fuelTankEditForm="ngForm">
      <mat-tab-group [(selectedIndex)]="vm.fuelTankTabIndex">
        <mat-tab>
          <ng-template mat-tab-label>
            <p class="mb-0">Fuel Tank Informations</p>
          </ng-template>
          <div class="wrapper">
            <mat-form-field class="mat-form-field-infix-class">
              <input matInput name="fuelTankAssetId" placeholder="QR Code Asset Id" type="text"
                     [(ngModel)]="vm.fuelTankAssetId"
                     (blur)="trimGeneratorLeadingAndTrailingSpaces('fuelTankAssetId')" />
              <button
                class="search-button"
                mat-mini-fab
                matSuffix
                type="button"
                [attr.aria-label]="vm.fuelTankScannerEnabled ? 'Close scanner' : 'Open scanner'"
                (click)="enableFuelTankScanner()">
                <mat-icon>qr_code_scanner</mat-icon>
              </button>
            </mat-form-field>

            <div *ngIf="vm.fuelTankScannerEnabled" class="scanner-container">
              <zxing-scanner
                #fuelTankScanner
                class="qr-reader"
                (scanSuccess)="fuelTankScanSuccessHandler($event)">
              </zxing-scanner>
              <div #focusFrame *ngIf="vm.fuelTankZoomFlag" class="focus-frame"></div>
              <div *ngIf="vm.fuelTankZoomFlag" class="zoom-controls">
                <button aria-label="Zoom in" class="zoom-icon" type="button" (click)="fuelTankZoomIn()">
                  <span aria-hidden="true" class="fa fa-search-plus"></span>
                </button>
                <button aria-label="Zoom out" class="zoom-icon" type="button" (click)="fuelTankZoomOut()">
                  <span aria-hidden="true" class="fa fa-search-minus"></span>
                </button>
              </div>
            </div>

            <mat-form-field class="mat-form-field-infix-class">
              <input matInput name="fuelTankLocalId" placeholder="Local ID" type="text" [(ngModel)]="vm.fuelTankLocalId"
                     (blur)="trimGeneratorLeadingAndTrailingSpaces('fuelTankLocalId')" />
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <input matInput name="fuelTankSerialNumber" placeholder="Serial Number" type="text"
                     [(ngModel)]="vm.fuelTankSerialNumber"
                     (blur)="trimGeneratorLeadingAndTrailingSpaces('fuelTankSerialNumber')" />
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <mat-select #statusCtrl="ngModel" name="fuelTankStatus" placeholder="Status" required
                          [(ngModel)]="vm.fuelTankSelectedStatus">
                <mat-option>--</mat-option>
                <mat-option *ngFor="let status of vm.statuses; trackBy: trackByStatus" [value]="status.id">
                  {{ status.statusType }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="statusCtrl.invalid && statusCtrl.touched">
                Status is required
              </mat-error>
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <mat-select #divisionCtrl="ngModel" name="fuelTankDivision" placeholder="Division" required
                          [(ngModel)]="vm.fuelTankSelectedDivision"
                          (selectionChange)="onFuelTankDivisionChange($event.value)">
                <mat-option>--</mat-option>
                <mat-option *ngFor="let division of vm.divisions; trackBy: trackByDivision" [value]="division.elementID">
                  {{ division.name }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="divisionCtrl.invalid && divisionCtrl.touched">
                Division is required
              </mat-error>
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <mat-select #regionCtrl="ngModel" name="fuelTankRegion" placeholder="Region" required
                          [(ngModel)]="vm.fuelTankSelectedRegion" [disabled]="vm.isRegionsLoading"
                          (selectionChange)="onFuelTankRegionChange($event.value)">
                <mat-option>--</mat-option>
                <mat-option *ngFor="let region of vm.regions; trackBy: trackByRegion" [value]="region.elementID">
                  {{ region.name}}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="regionCtrl.invalid && regionCtrl.touched">
                Region is required
              </mat-error>
              <mat-hint *ngIf="vm.isRegionsLoading">Loading regions...</mat-hint>
              <mat-hint *ngIf="!vm.isRegionsLoading && !(vm.regions?.length > 0)">Select a division first</mat-hint>
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <mat-select #ownerTeamCtrl="ngModel" name="fuelTankTeam" placeholder="Owner Team" required
                          [(ngModel)]="vm.fuelTankSelectedTeam" [disabled]="vm.isTeamsLoading"
                          (selectionChange)="onFuelTankTeamChange($event.value)">
                <mat-option>--</mat-option>
                <mat-option *ngFor="let team of vm.teams; trackBy: trackByTeam" [value]="team">
                  {{ team }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="ownerTeamCtrl.invalid && ownerTeamCtrl.touched">
                Team is required
              </mat-error>
              <mat-hint *ngIf="!vm.fuelTankSelectedRegion">Select a region first</mat-hint>
              <mat-hint *ngIf="vm.fuelTankSelectedRegion && vm.isTeamsLoading">Loading teams...</mat-hint>
              <mat-hint *ngIf="vm.fuelTankSelectedRegion && !vm.isTeamsLoading && !(vm.teams?.length > 0)">
                No teams found
              </mat-hint>
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <mat-select name="fuelTankTrailer" placeholder="Trailer Name" [(ngModel)]="vm.fuelTankSelectedTrailer"
                          [disabled]="vm.isTrailerLoading">
                <mat-option>--</mat-option>
                <mat-option *ngFor="let trailer of vm.trailers; trackBy: trackByTrailerId" [value]="trailer.trailerId">
                  {{ trailer.trailerName ? trailer.trailerName : 'Anonymous Trailer' }}
                </mat-option>
              </mat-select>
              <mat-hint *ngIf="!vm.fuelTankSelectedTeam">Select an Owner Team first</mat-hint>
              <mat-hint *ngIf="vm.fuelTankSelectedTeam && vm.isTrailerLoading">Loading Trailers...</mat-hint>
              <mat-hint
                *ngIf="vm.fuelTankSelectedTeam && !vm.isTrailerLoading && !vm.trailers.length">
                No Trailers Found
              </mat-hint>
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <mat-select name="fuelTankLoanedToTeam" placeholder="Loaned To Team"
                          [(ngModel)]="vm.fuelTankLoanedToTeam">
                <mat-option>--</mat-option>
                <mat-option *ngFor="let team of vm.loanedToTeams; trackBy: trackByTeam" [value]="team">
                  {{ team }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <mat-select #fuelTankCapacityCtrl="ngModel" name="fuelTankCapacity" placeholder="Capacity (Gallons)"
                          required [(ngModel)]="vm.fuelTankSelectedCapacity">
                <mat-option>--</mat-option>
                <mat-option *ngFor="let fuelTankSize of vm.fuelTankCapacities; trackBy: trackByFuelTankSize"
                            [value]="fuelTankSize.fuelTankSize">
                  {{ fuelTankSize.fuelTankSize }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="fuelTankCapacityCtrl.invalid && fuelTankCapacityCtrl.touched">
                Fuel Tank Capacity is required
              </mat-error>
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <mat-label for="fuelTankComments">Comments</mat-label>
              <textarea id="fuelTankComments" matInput
                        name="fuelTankComments" rows="3"
                        [(ngModel)]="vm.fuelTankComments"
                        (blur)="trimGeneratorLeadingAndTrailingSpaces('fuelTankComments')">
              </textarea>
            </mat-form-field>
          </div>
        </mat-tab>

        <mat-tab>
          <ng-template mat-tab-label>
            <p class="mb-0">Location Information</p>
          </ng-template>
          <div class="wrapper">
            <mat-form-field class="mat-form-field-infix-class">
              <input matInput name="fuelTankAddress" placeholder="Address" type="text" [(ngModel)]="vm.fuelTankAddress"
                     (blur)="trimGeneratorLeadingAndTrailingSpaces('fuelTankAddress')" />
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <input matInput name="fuelTankCity" placeholder="City" type="text" [(ngModel)]="vm.fuelTankCity"
                     (blur)="trimGeneratorLeadingAndTrailingSpaces('fuelTankCity')" />
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <mat-select name="fuelTankState" placeholder="State" [(ngModel)]="vm.fuelTankState">
                <mat-option>--</mat-option>
                <mat-option *ngFor="let state of vm.states; trackBy: trackByState" [value]="state.name">
                  {{ state.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field class="mat-form-field-infix-class">
              <input matInput maxlength="5" minlength="5" name="fuelTankZipcode" placeholder="Zip Code" type="text"
                     [(ngModel)]="vm.fuelTankZipcode" (blur)="trimGeneratorLeadingAndTrailingSpaces('fuelTankZipcode')"
                     (keypress)="numberOnly($event)" (paste)="restrictPasteForText($event)" />
            </mat-form-field>

            <form *ngIf="vm.fuelTankLocationInfoForm" [formGroup]="vm.fuelTankLocationInfoForm">
              <mat-form-field class="mat-form-field-bottom-margin mat-form-field-infix-class">
                <input formControlName="currentGpsLatitude" matInput placeholder="Current Gps Latitude xx.xxxxxx"
                       (change)="trimSpaces('vm.currentGpsLatitude')"
                       (ngModelChange)="onChangeLocation(vm.fuelTankLocationInfoForm)">
                <mat-error *ngIf="vm.fuelTankLocationInfoForm?.get('currentGpsLatitude')?.hasError('validateDecimal')">
                  Latitude <span class="text-type-bold">Must</span>
                  Be 6-12 Characters After Decimal and Correctly Formatted !
                </mat-error>
                <mat-error *ngIf="vm.fuelTankLocationInfoForm?.get('currentGpsLatitude')?.hasError('validateRange')">
                  {{ vm.fuelTankLocationInfoForm?.get('currentGpsLatitude')?.errors?.validateRange }}
                </mat-error>
              </mat-form-field>

              <mat-form-field class="mat-form-field-bottom-margin mat-form-field-infix-class">
                <input formControlName="currentGpsLongitude" matInput placeholder="Current Gps Longitude -xx.xxxxxx"
                       (change)="trimSpaces('vm.currentGpsLongitude')"
                       (ngModelChange)="onChangeLocation(vm.fuelTankLocationInfoForm)">
                <mat-error *ngIf="vm.fuelTankLocationInfoForm?.get('currentGpsLongitude')?.hasError('validateDecimal')">
                  Longitude <span class="text-type-bold">Must</span>
                  Be 6-12 Characters After Decimal and Correctly Formatted !
                </mat-error>
                <mat-error *ngIf="vm.fuelTankLocationInfoForm?.get('currentGpsLongitude')?.hasError('validateRange')">
                  {{ vm.fuelTankLocationInfoForm?.get('currentGpsLongitude')?.errors?.validateRange }}
                </mat-error>
                <span class="mac-button" matSuffix><span class="fa fa-mouse-pointer" matSuffix></span>
                  <a href="https://www.google.com/maps/search/?api=1&query={{vm.fuelTankLocationInfoForm?.value?.currentGpsLatitude}},{{vm.fuelTankLocationInfoForm?.value?.currentGpsLongitude}}"
                     target="_blank">Show on Map</a>
                </span>
              </mat-form-field>
            </form>
          </div>
        </mat-tab>
      </mat-tab-group>
    </form>
  </div>
</div>
